<template id="basket">
  <div>
     <modal v-if="showModalBasket" frame position="top" size="fluid" @close="showModalBasket = false, $emit('closeBasket')">
        <modal-header color="blue-grey darken-4">
          <modal-title>Заказ</modal-title>
          </modal-header>
        <modal-body>
           <!-- basket -->
     <tbl responsive striped :sorting="true">
        <tbl-head color="blue-grey" textWhite>
          <tr>
            <th scope="col">№</th>
            <th scope="col">Наименование</th>
            <th scope="col">Цена, {{ selectedContragent.priceCurrency }}</th>
            <th class="col-md-2 col-sm-3 col-xs-6" scope="col">Кол-во</th>
            <th scope="col">Изменить</th>
          </tr>
        </tbl-head>
        <tbl-body>
          <mdb-datatable v-if="false"
                :data="tabledata"
                striped
                bordered
                responsive
                :order="[0, 'dec']"
                />
          <tr v-for="(good, index) in selectedContragentBasket" :key="index" >
            <th>{{index+1}}</th>
            <th>{{good.NomCode+' '}}{{good.NomNaim}}</th>
            <th>{{good.Price}}</th>
            <th> <div class="input-group-prepend">
               <span class="input-group-text text-white red hoverable" @click = "good.Quantity = '', $emit('addGood', good)" title="Удалить"><i class="fa fa-times text-grey" aria-hidden="true" title="Удалить"></i></span>
                <input class="input-group-append md-2" type='number' v-model="good.Quantity" @input="good.Quantity=calculateInput(good,$event)" aria-label="Заказано" title="Используйте стрелки вверх-вниз для изменения количества"/>
             </div>
             </th>
            <th><div class="input-group-append">
              <span class="input-group-text text-white blue-grey darken-3 hoverable form-control" @click = "good.OrderedQty=good.ConfirmedQty,$emit('addGood', good)" title="Изменить"><i class="fas fa-cart-arrow-down"></i>
              </span>
            </div></th>
          </tr>
        </tbl-body>
        <tbl-head color="blue-grey" textWhite>
       <tr>
            <th scope="col"></th>
            <th scope="col">ИТОГО с НДС:</th>
            <th scope="col" class="th-lg">{{orderedAmount()}}</th>
            <th scope="col" class="th-lg"></th>
            <th scope="col"></th>
          </tr>
       </tbl-head>
      </tbl>
      <div v-if="orderedAmount() < 250 && orderedAmount() > 0 && selectedContragent.priceCurrency === 'BYN'">
        <h6>Увеличьте сумму заказа до 250+ BYN и получите <badge class="green darken-4">БЕСПЛАТНУЮ ДОСТАВКУ</badge></h6>
      </div>
       <blockquote v-if="просроченныйДолг>100" class="blockquote bq-danger">
           <div v-if="просроченныйДолг>100 && selectedContragent.priceCurrency === 'BYN' && this.максДнейПросрочки <= -30">
            <h6>Просроченная задолженность <badge color="red">{{просроченныйДолг}} {{selectedContragent.priceCurrency}}</badge><br></h6>
            <h6>Для отправки этого заказа необходимо сделать <b>ПРЕДОПЛАТУ</b> в сумме не менее суммы заказа + <badge color="red">{{просроченныйДолг}} BYN.</badge></h6>
          </div>
          <div v-if="просроченныйДолг>100 && selectedContragent.priceCurrency === 'BYN' && this.максДнейПросрочки > -30">
            <h6>Просроченная задолженность <badge color="red">{{просроченныйДолг}} {{selectedContragent.priceCurrency}}</badge><br></h6>
            <h6>Для отправки этого заказа необходимо сделать <b>ПРЕДОПЛАТУ</b> в сумме не менее суммы заказа + <badge color="red">{{Math.round(просроченныйДолг/4)}} BYN.</badge></h6>
          </div>
        </blockquote>
        </modal-body>
          <modal-footer class="d-flex justify-content-center">
              <btn class="blue-grey darken-4" @click.native="$emit('closeBasket'), showModalBasket = false, showModalOrder = false">Назад</btn>
            <template>
            <div class="btn btn-sm default-color" style="font-size: 12px;">

              <input title = "Импорт из файла XLSX" type="file" @change="onChange" />
              <xlsx-read :file="file">
                <xlsx-json  @parsed="handleParsed">
                  <template #collection="{ collection }">
                    <div v-if="collection">
                      <ul>
                        <li v-for="item in collection" :key="item.id">
                          {{ item }}
                        </li>
                      </ul>
                    </div>
                  </template>
                </xlsx-json>
              </xlsx-read>
            </div>
          </template>
              <btn btn-call color="cyan accent-4" @click.native="showModalOrder = true, showModalBasket = false, file = null">Оформить заказ</btn>
          </modal-footer>
      </modal>
  <div class="mt-5">
       <modal  size="lg" v-if="showModalOrder">
        <modal-header class="blue-grey darken-2 white-text" @close="showModalOrder = false, $emit('closeBasket'), file = null">
          <modal-title>Детали заказа</modal-title>
        </modal-header>
        <modal-body>
        <div v-if="false" class="row">
        <div v-if="false" class="col">
       <!-- Group of default radios - option 1 -->
          <div v-if="false" class="custom-control custom-radio">
            <input @change="$emit('Самовывоз'), address = warehouse, delivery = 'Самовывоз'" type="radio" class="custom-control-input" id="Самовывоз" name="groupOfDelivery" checked>
            <label class="custom-control-label" for="Самовывоз">Самовывоз</label>
          </div>

          <!-- Group of default radios - option 2 -->
          <div v-if="false" class="custom-control custom-radio">
            <input @change="$emit('Доставка'), address = clientaddress, delivery = 'Доставка'" type="radio" class="custom-control-input" id="Доставка" name="groupOfDelivery">
            <label class="custom-control-label" for="Доставка">Доставка</label>
          </div>
        </div>
         <div v-if="false" class="col">
       <!-- Group of default radios - option 3 -->
          <div class="custom-control custom-radio">
            <input @change="$emit('Предоплата'), payment = 'Предоплата' " type="radio" class="custom-control-input" id="Предоплата" name="groupOfPayment" checked>
            <label class="custom-control-label" for="Предоплата">Предоплата</label>
          </div>

          <!-- Group of default radios - option 4 -->

          </div>
    </div>
        <!-- Default form contact -->
<form>
     <!-- Default input name -->
    <label v-if="false" for="defaultFormContactNameEx" class="grey-text">Адрес</label>
    <input v-if="false" v-model="address" type="text" id="defaultFormContactNameEx" class="form-control">

    <br>

    <!-- Default input email -->
    <label for="defaultFormContactEmailEx" class="grey-text">Ваш email</label>
    <input v-model="email" type="email" id="defaultFormContactEmailEx" class="form-control">

    <br>
    <!-- Default input email -->
    <label for="defaultFormContactEmailEx1" class="grey-text">Email менеджера</label>
    <input v-model="this.selectedContragentManager.EMail" type="email" id="defaultFormContactEmailEx1" class="form-control">

    <br>

    <!-- Default input subject -->
    <label for="defaultFormContactSubjectEx" class="grey-text">Телефон</label>
    <input v-model="phone" type="text" id="defaultFormContactSubjectEx" class="form-control">

    <br>

    <!-- Default textarea message -->
    <label for="defaultFormContactMessageEx" class="grey-text">Комментарий к заказу</label>
     <div class="form-group">
       <textarea v-model="newcomment" class="form-control" id="exampleFormControlTextarea1" rows="1"></textarea>
      </div>
</form>
<!-- Default form contact -->
          <div class="input-group d-flex justify-content-center">
           <div class="input-group-prepend">
             <span class="input-group-text green-text">
                 Сумма заказа {{orderedAmount() }} {{selectedContragent.priceCurrency}}
             </span>
           </div>
                 <div class="input-group-append">
                    <span v-if="(orderedAmount() > 250 && selectedContragent.priceCurrency === 'BYN')" class="input-group-text green-text">
                        Бесплатная доставка
                    </span>
                    <span v-if="(orderedAmount() < 250 && selectedContragent.priceCurrency === 'BYN')" class="input-group-text">
                         До бесплатной доставки {{Math.round((250-orderedAmount()) * 100) / 100 }} {{selectedContragent.priceCurrency}}
                   </span>
                </div>
          </div>
       </modal-body>
        <modal-footer>
          <btn class="blue-grey darken-4" @click.native="$emit('closeBasket'), showModalOrder = false">Назад</btn>
          <btn class="cyan accent-4" @click.native="postOrder(), showModalOrder = false, $emit('closeBasket')">Разместить заказ</btn>
        </modal-footer>
      </modal>
  </div>
 </div>
 </template>

<script>
import { Row, Column, Btn, Card, Container, CardBody, CardHeader, CardText, Fa, BarChart, PieChart, LineChart, RadarChart, DoughnutChart, ListGroup, ListGroupItem, Badge, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, mdbTooltip, mdbPopover, mdbBtn, mdbBadge, NumericInput, Tbl, TblHead, TblBody, mdbDatatable } from 'mdbvue'
import ApiService from '@/services/ApiService'
import { XlsxRead, XlsxJson } from 'vue-xlsx/dist/vue-xlsx.es.js'
export default {
  name: 'basket',
  components: {
    XlsxRead,
    XlsxJson,
    Row,
    Container,
    Column,
    Btn,
    Card,
    CardBody,
    CardHeader,
    CardText,
    Fa,
    BarChart,
    PieChart,
    LineChart,
    RadarChart,
    DoughnutChart,
    ListGroup,
    ListGroupItem,
    Badge,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    mdbTooltip,
    mdbPopover,
    mdbBtn,
    mdbBadge,
    NumericInput,
    Tbl,
    TblHead,
    TblBody,
    mdbDatatable
  },
  props: ['prices', 'mng', 'максДнейПросрочки', 'showBasket', 'goods', 'selectedContragent', 'selectedContragentBasket', 'selectedContragentManager', 'orders', 'activeOrder', 'user', 'comment', 'goodsInfotronic', 'просроченныйДолг', 'долг'],
  event: 'close',
  watch: {
    showBasket () {
      this.showModalBasket = this.ShowBasket
    }
  },
  data () {
    return {
      collection: null,
      file: null,
      errors: [],
      postBody: '',
      search: '',
      found: false,
      newcomment: '',
      showModalOrder: false,
      showModalBasket: true,
      warehouse: 'г. Минск, улица Якуба Коласа, дом 53, корпус 3, офис 149',
      address: 'г. Минск, улица Якуба Коласа, дом 53, корпус 3, офис 149',
      payment: 'Предоплата',
      delivery: 'Самовывоз',
      clientaddress: '',
      email: '',
      phone: '',
      tabledata: {
        columns: [
          {
            label: 'Выручка,$',
            field: 'Sales',
            sort: 'asc'
          },
          {
            label: 'Наименование',
            field: 'Name',
            sort: 'asc'
          }
        ],
        rows: this.selectedContragentBasket.NomCode
      }
    }
  },
  mounted () {
    console.log('mounted basket')
    console.log(JSON.stringify(this.user))
    this.email = this.selectedContragent.EmailDlyaRassylky
    window.addEventListener('keydown', this.escCloseModal)
    // if (this.comment === '') {
    this.newcomment = this.comment
    // }
  },
  destroyed () {
    window.removeEventListener('keydown', this.escCloseModal)
  },
  updated () {
  },
  computed: {
    orderedList () {
      if (this.goods.length > 0) {
        return this.goods.filter(good => {
          if (good.Quantity > 0) {
            return true
          } else {
            return false
          }
        }
        )
      }
    }
  },
  methods:
    {
      getPrice (goodCode) {
        var res = this.prices.filter(price => (price.NomCode === goodCode))
        if (res.length === 0) return 0
        return res[0].Cena
      },
      onChange (event) {
        this.file = event.target.files ? event.target.files[0] : null
      // console.log(JSON.stringify(this.file))
      },
      async handleParsed (parsedData) {
        // console.log(parsedData) // Обработка данных после парсинга
        parsedData.forEach(excel => {
          var good = this.goods.filter(good => good.NomCode === excel.Код.toString())
          if (good.length === 1) {
            good[0].OrderedQty = excel.Количество
            good[0].ConfirmedQty = excel.Количество
            good[0].Quantity = excel.Количество
            good[0].Price = this.getPrice(excel.Код.toString())
            this.$emit('addGood', good[0])
            // console.log(good[0])
            // console.log(good.length)
          }
        })

        this.$dialog.alert('Заказ из файла успешно импортирован! ').then(function (dialog) {
        })
        this.file = null
        console.log('this.file is set to ', this.file)
      },
      calculateInput (good, event) {
        // console.log(event.target.value)
        if (event.target.value <= 0 || good.OrderedQty <= 0 || good.ConfirmedQty <= 0) {
          good.OrderedQty = 1
          good.ConfirmedQty = 1
          good.changed = true
          event.target.value = 1
          return 1
        } else return event.target.value
      },
      escCloseModal (e) {
        // console.log('pressed ' + e.key)
        if (e.key === 'Escape') {
          this.showModalBasket = false
          this.$emit('closeBasket')
        }
      },
      calculateid (refkey) {
        return 'i' + refkey
      },
      isDelete (good, index, event) {
        if (event.target.value < 1) {
          this.$dialog
            .confirm('Для изменения количества используйте стрелки вверх-вниз. Удалить товар из корзины?')
            .then(function (dialog, event) {
              // console.log('Clicked on proceed ')
              good.Quantity = 0
              this.$emit('addGood', good)
              // console.log(good.ConfirmedQty)
            })
            .catch(function () {
              // console.log('Clicked on cancel')
              // event.target.value = 1
              // console.log(good.ConfirmedQty)
              // good.OrderedQty = good.ConfirmedQty
            })
        } else {
          // console.log('Else')
          // this.orderedList[index].OrderedQty = event.target.value
        }
      },
      async postOrder () {
        // this.$emit('postOrder')
        await this.$emit('emptyBasket')
        let response = await ApiService.sendOrderFile(this.selectedContragent.UNP, this.newcomment, this.selectedContragent.EmailDlyaRassylky, this.selectedContragentManager.EMail, JSON.stringify(this.user))
        if (response.data !== null) {
          console.log('response.data ' + response.data.Ordernumber)
          console.log('response.data ' + response.data.OrderDate)
          var info = JSON.stringify(response.data)
          console.log('файл корзины ' + info)

          try {
            let response1 = await ApiService.deleteOrderFile(this.selectedContragent.UNP)
            console.log('Удаление: ' + JSON.stringify(response1))

            this.$dialog.alert('Заказ отправлен в обработку! Номер вашего заказа в системе:' + response.data.Ordernumber + '<br> Вы можете отследить статус вашего заказа в разделе "Список заказов" ')
              .then(function (dialog) {
                // Код, который выполнится после закрытия диалогового окна
              })
          } catch (error) {
            this.$dialog.alert('Не могу отправить заказ в обработку, повторите попытку позже!')
              .then(function (dialog) {
                // Код, который выполнится после закрытия диалогового окна
              })
          }
        }

        // await new Promise(resolve => setTimeout(resolve, 1))

        // this.selectedContragentBasket = []
      },
      orderedAmount () {
        // console.log(this.selectedContragentBasket)
        if (this.selectedContragentBasket === undefined) {
          return 0
        }
        var sum = 0.0
        this.selectedContragentBasket.forEach((item) => {
          sum += item.Price * Number(item.Quantity)
          // console.log(sum)
        })
        return Math.round(sum * 100) / 100
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  border-radius: 1.5rem;
 }
.form-control:focus {
    border:0px
    }
.order-btn {
    margin-top: 0.375rem;
    margin-left: 0rem;
    }
.search {
    border: 1px solid #1e282d;
    }
.stock {
    border: 1px solid #007e33;
    }
.miss {
    border: 1px solid #ffbb33;
    }
.transit {
    border: 1px solid #ff8800;
    }
.w-120 {
    width: 120px!important;
}
.w-50 {
    width: 60px!important;
}
.inp {
    font-size: 1.5rem;
}
.md-form {
    position: relative;
    margin-top: 0rem;
    margin-bottom: 0rem;
}
.cascading-admin-card {
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 5px;
}
.m-0 {
    margin: 0.4rem!important;
}
.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}
.cascading-admin-card .admin-up .fa {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 20px 0 rgba(0, 0, 0, 0.19);
}
.cascading-admin-card .admin-up .fa {
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
}
.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}
.admin-up .data p {
  color: #999999;
  font-size: 12px;
}
.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}
  .card-text {
  font-size: 16px;
  opacity: 1.0;
  margin-bottom: 0;
  margin-left: 1rem;
  font-weight: 300;
}
.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Basket.vue